<template>
	<div class="upgrade-tip" @click="$emit('close')">
		<img v-if="isAdvance && isCn" src="./advanced_tip.png" alt="" />
		<img v-if="isAdvance && !isCn" src="./advanced_tip_en.png" alt="" />
		<img v-if="!isAdvance && isCn" src="./professional_tip.png" alt="" />
		<img v-if="!isAdvance && !isCn" src="./professional_tip_en.png" alt="" />
	</div>
</template>
<script>
export default {
	computed: {
		isAdvance() {
			return PageInfo.accountState === 3
		},
		isCn() {
			return Constants.LOCAL_LANGUAGE === 'zh'
		},
	},
}
</script>
<style lang="scss" scoped>
img {
	width: 300px;
	height: 81px;
}

@keyframes slide {
	from {
		margin-top: 0;
	}
	to {
		margin-top: 6px;
	}
}

.upgrade-tip {
	position: absolute;
	left: 0;
	right: 0;
	z-index: 1;
	animation: 0.5s slide ease infinite alternate;
}
</style>
